import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FloorService {
  private floorDataSubject = new BehaviorSubject<any>(null);
  public floorData$ = this.floorDataSubject.asObservable();

  private builingMapEntityStreetViewSubject = new BehaviorSubject<any>(null);
  public builingMapEntityStreetView$ = this.builingMapEntityStreetViewSubject.asObservable();

  private floorMapVisible = new BehaviorSubject<boolean>(false);
  floorMapVisibility$ = this.floorMapVisible.asObservable();
   private incidentVisualizerVisible = new BehaviorSubject<boolean>(false);
  incidentVisualizerVisibility$ = this.incidentVisualizerVisible.asObservable();

  private incidentVisualizerVisibilitySubject = new BehaviorSubject<boolean>(false);
  // incidentVisualizerVisibility$ = this.incidentVisualizerVisibilitySubject.asObservable();

  private mapEntityIdSubject = new BehaviorSubject<string | null>(null);
  mapEntityId$ = this.mapEntityIdSubject.asObservable();

  private safeZoneStatusSubject = new BehaviorSubject<{ isActive: boolean; eventId?: string }>({ isActive: false });
  public safeZoneStatus$ = this.safeZoneStatusSubject.asObservable();

  setSafeZoneStatus(status: boolean, eventId?: string) {
    this.safeZoneStatusSubject.next({ isActive: status, eventId });
  }

  constructor() {}

  updateFloorData(floor: any) {
    this.floorDataSubject.next(floor);
  }

   updateStreetViewData(floor: any) {
    this.builingMapEntityStreetViewSubject.next(floor);
  }
  
   toggleGrandchild(visible: boolean) {
    this.floorMapVisible.next(visible);
  }

  
   updateIncidentVisualizer(visible: boolean) {
    this.incidentVisualizerVisible.next(visible);
  }

  setIncidentVisualizerVisibility(visible: boolean) {
    this.incidentVisualizerVisibilitySubject.next(visible);
  }

  setIncidentVisualizerMapEntityId(id: string) {
    this.mapEntityIdSubject.next(id);
  }
}
